import { ApolloError } from "@apollo/client";
import { useCallback } from "react";
import {
  UpdateCartData,
  UpdateCartProps,
  useUpdateCart,
} from "src/hooks/useUpdateCart";
import { CartInfo } from "src/types/cartInfo";

interface SetLineItemSupplyChannelHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  setLineItemSupplyChannel: (
    lineItemId: string,
    channelId: string,
    cartInfo: CartInfo
  ) => void;
}

function useSetLineItemSupplyChannel({
  refetchQueries = [],
  onCompleted,
}: UpdateCartProps = {}): SetLineItemSupplyChannelHook {
  const { updateCart, data, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
  });

  const setLineItemSupplyChannel: SetLineItemSupplyChannelHook["setLineItemSupplyChannel"] =
    useCallback(
      (lineItemId, channelId, cartInfo) =>
        void updateCart({
          cartInfo,
          actions: [
            {
              setLineItemSupplyChannel: {
                lineItemId,
                supplyChannel: {
                  id: channelId,
                },
              },
            },
          ],
        }),
      [updateCart]
    );

  return { setLineItemSupplyChannel, data, loading, error };
}

export { useSetLineItemSupplyChannel };
